import { inject, Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MpsTranslateTitleResolver implements Resolve<string> {
  private _translateService = inject(TranslateService);

  async resolve(route: ActivatedRouteSnapshot): Promise<string> {
    const titleKey = route.data.titleKey;

    if (!titleKey) {
      return environment.appName;
    }

    const translation = await firstValueFrom(this._translateService.get(titleKey));
    return `${translation} | ${environment.appName}`;
  }
}
